import {
  LayoutDashboard, Users2, GitPullRequestArrow, UserPlus, FileText, Truck,
  Route, MapPin, Wrench, ListChecks, Bell, BarChart3, Globe, Image,
  Users, Settings, ScrollText, Car, Inbox, Star, Contact, CalendarRange, Send, Radar, Upload, Map as MapIcon, Timer,
} from "lucide-react";

export const NAV_ITEMS = [
  { to: "/app", label: "Dashboard", icon: LayoutDashboard, perm: "dashboard:view", end: true },
  { to: "/app/driver", label: "Driver Workspace", icon: Car, perm: "driver:access" },
  { to: "/app/inbox", label: "Inbox", icon: Inbox, perm: "crm:view" },
  { to: "/app/crm", label: "CRM", icon: Users2, perm: "crm:view" },
  { to: "/app/referrals", label: "Referrals", icon: GitPullRequestArrow, perm: "referrals:view" },
  { to: "/app/applicants", label: "Applicants", icon: UserPlus, perm: "applicants:view" },
  { to: "/app/documents", label: "Documents", icon: FileText, perm: "documents:view" },
  { to: "/app/fleet", label: "Fleet", icon: Truck, perm: "fleet:view" },
  { to: "/app/customers", label: "Customers", icon: Contact, perm: "customers:view" },
  { to: "/app/schedule", label: "Master Schedule", icon: CalendarRange, perm: "schedule:view" },
  { to: "/app/dispatch", label: "Dispatch", icon: Send, perm: "dispatch:view" },
  { to: "/app/trips", label: "Trips", icon: Route, perm: "trips:view" },
  { to: "/app/routes", label: "Dispatch & Routes", icon: MapIcon, perm: "tracking:view" },
  { to: "/app/live-tracking", label: "Live Tracking", icon: Radar, perm: "tracking:view" },
  { to: "/app/tracking", label: "GPS Demo", icon: MapPin, perm: "tracking:view" },
  { to: "/app/maintenance", label: "Maintenance", icon: Wrench, perm: "maintenance:view" },
  { to: "/app/tasks", label: "Tasks", icon: ListChecks, perm: "tasks:view" },
  { to: "/app/reviews", label: "Reviews", icon: Star, perm: "cms:view" },
  { to: "/app/notifications", label: "Notifications", icon: Bell, perm: "notifications:view" },
  { to: "/app/reports", label: "Reports", icon: BarChart3, perm: "reports:view" },
  { to: "/app/shift-hours", label: "Shift Hours", icon: Timer, perm: "reports:view" },
  { to: "/app/cms", label: "Website CMS", icon: Globe, perm: "cms:view" },
  { to: "/app/media", label: "Media Library", icon: Image, perm: "media:view" },
  { to: "/app/users", label: "Users", icon: Users, perm: "users:view" },
  { to: "/app/imports", label: "Data Import", icon: Upload, perm: "customers:manage" },
  { to: "/app/settings", label: "Settings", icon: Settings, perm: "settings:view" },
  { to: "/app/audit", label: "Audit Logs", icon: ScrollText, perm: "audit:view" },
];
